var installedModules = {};
var moduleToHandlerMapping = {
	3732: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(6540); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	1995: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(4848); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	1924: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	865: {
		getter: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(6417), __webpack_require__.e(6715), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(6715); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	3224: {
		getter: function() { return Promise.all([__webpack_require__.e(8216), __webpack_require__.e(1106), __webpack_require__.e(5547)]).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	9914: {
		getter: function() { return Promise.all([__webpack_require__.e(6417), __webpack_require__.e(8122), __webpack_require__.e(6066)]).then(function() { return function() { return __webpack_require__(514); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	8006: {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(9965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	4178: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	8712: {
		getter: function() { return __webpack_require__.e(2140).then(function() { return function() { return __webpack_require__(9759); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	7733: {
		getter: function() { return __webpack_require__.e(8501).then(function() { return function() { return __webpack_require__(882); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	7070: {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false,
			  "layer": null
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	8122: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(3732)]).then(function() { return function() { return __webpack_require__(961); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	9252: {
		getter: function() { return Promise.all([__webpack_require__.e(9522), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(9522); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.30",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-react-utils",
	},
	5534: {
		getter: function() { return __webpack_require__.e(6682).then(function() { return function() { return __webpack_require__(4301); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.102",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ferreri/minato-auth-react",
	},
	5464: {
		getter: function() { return __webpack_require__.e(1106).then(function() { return function() { return __webpack_require__(1106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	3780: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(3368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.4.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	3292: {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__(4953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	}
};
var initialConsumes = [3732,1995,1924,865,3224,9914,8006,4178,8712,7733,3732,7070,8122,1995,865,9252,5534,5464,3780,3292];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"636": [
		1995,
		865,
		9252,
		5534,
		5464,
		3780,
		3292
	],
	"1995": [
		1995
	],
	"3732": [
		3732
	],
	"4301": [
		9252
	],
	"5527": [
		1924,
		865,
		3224,
		9914,
		8006,
		4178,
		8712,
		7733
	],
	"8122": [
		8122
	],
	"8792": [
		3732,
		7070,
		8122
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}